import { ref, provide, inject } from "vue";
const LanguageKey = Symbol("language");
export function provideLanguage() {
    const language = ref("cz");
    const setLanguage = (lang) => {
        language.value = lang;
    };
    const context = {
        language,
        setLanguage,
    };
    provide(LanguageKey, context);
    return context;
}
export function useLanguage() {
    const context = inject(LanguageKey);
    if (!context) {
        throw new Error("useLanguage must be used within a component that calls provideLanguage");
    }
    return context;
}
